import { Category } from 'shared/types';
import EyesIcon from 'shared/components/icons/EyesIcon';
import HairIcon from 'shared/components/icons/HairIcon';
import SkinIcon from 'shared/components/icons/SkinIcon';
import NoseIcon from 'shared/components/icons/NoseIcon';
import MouthIcon from 'shared/components/icons/MouthIcon';
import EarsIcon from 'shared/components/icons/EarsIcon';
import AccessoriesIcon from 'shared/components/icons/AccessoriesIcon';
import BackgroundsIcon from 'shared/components/icons/BackgroundsIcon';
import FacialHairIcon from 'shared/components/icons/FacialHairIcon';
import LogoIcon from 'shared/components/icons/LogoIcon';

interface Props {
  category: string;
  color: string;
}

const CategoryIcon = ({ category, color }: Props) => {
  switch (category) {
    case Category.HEAD:
      return <SkinIcon color={color} />;
    case Category.HAIR:
      return <HairIcon color={color} />;
    case Category.EYES:
      return <EyesIcon color={color} />;
    case Category.NOSE:
      return <NoseIcon color={color} />;
    case Category.MOUTH:
      return <MouthIcon color={color} />;
    case Category.EARS:
      return <EarsIcon color={color} />;
    case Category.FACIAL_HAIR:
      return <FacialHairIcon color={color} />;
    case Category.ACCESSORIES:
      return <AccessoriesIcon color={color} />;
    case Category.BACKGROUND:
      return <BackgroundsIcon color={color} />;
    case Category.LOGO:
      return <LogoIcon color={color} />;
    default:
      return null;
  }
}

export default CategoryIcon;
